export default "__VITE_ASSET__8d4b0d0b__"